function isAbsoluteUrl(value: string) {
  if (!value) return false;
  const pat = /^https?:\/\//i;
  return pat.test(value);
}

export default isAbsoluteUrl;
